import React from 'react';
import PropTypes from 'prop-types';
import Svg, { G, Path } from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';

function CrossIcon(props) {
  const {
    color,
    ...svgProps
  } = props;

  return (
    <Svg
      {...svgProps}
      viewBox="0 0 24 24"
    >
      <G fill={color} fillRule="evenodd">
        <Path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
        <Path d="M0 0h24v24H0z" fill="none" />
      </G>
    </Svg>
  );
}

CrossIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

CrossIcon.defaultProps = {
  height: 16,
  width: 16,
};

export default pure(CrossIcon);
